import React from "react";
import { useNavigate, useLocation } from "react-router-dom";

import "../Styles/index.css";
import "./IntranetRedTheme.css";

import AvisosUsuario from "./usuario/AvisosUsuario";

export default function IntranetUsuarioAvisosPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const initialItem = location.state?.initialItem;

  return (
    <div className="intranet-red-theme">
      <AvisosUsuario
        onVolver={() => navigate("/menu/intranet/usuario")}
        initialItem={initialItem}
      />
    </div>
  );
}
